import React from 'react';
import { LocalizationContext } from '../../../hoc/Localization';
import styles from './styles.less';

const Header = () => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <div className={styles.header_container}>
      <div className={styles.header_image}>
        <img src="/static/images/wizard/wizHeaderImg.jpg" alt="header_image" />
      </div>
      <div className={styles.header_text}>
        <h2 className={styles.header_title}>{t('wizard.header.title')}</h2>
        <p className={styles.header_description}>{t('wizard.header.description')}</p>
      </div>
    </div>
  );
};

export default Header;
